import React from "react";
import "./SuccessBooking.css";

const SuccessScreen = () => {
  return (
    <div className="success-page">
      <div className="success-box">
        <div className="checkmark">✅</div>
        <h1>Successful Registration</h1>
        <p>
          You have successfully registered for the masterclass.<br />
          You will be shared the link and all details through WhatsApp.
        </p>
      </div>
    </div>
  );
};

export default SuccessScreen;